import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LgaStoreActions, LgaStoreSelectors, LgaStoreReducer } from './index';
import { LgaDto } from '@cradua/data';

@Injectable()
export class LgaFacade {
  constructor(private store: Store<LgaStoreReducer.LgaPartialState>) {}

  lgaRecord$ = this.store.select(LgaStoreSelectors.getSelected);
  lgaRecordError$ = this.store.select(LgaStoreSelectors.getLgaError);

  getselected() {
    return this.store.select(LgaStoreSelectors.getSelected);
  }

  get isLoadingLga() {
    this.store.dispatch(LgaStoreActions.loadLga());
    return this.store.select(LgaStoreSelectors.loadingLga);
  }

  get loadLga() {
    this.store.dispatch(LgaStoreActions.loadLga());
    return this.store.select(LgaStoreSelectors.getAllLga);
  }

  addLga(newLga: LgaDto[]) {
    this.store.dispatch(LgaStoreActions.addLga({ newLga }));
  }

  updateLga(updateLga: LgaDto[]) {
    this.store.dispatch(LgaStoreActions.updateLga({ updateLga }));
  }

  removeLga(ids: string[]) {
    console.log('id ', ids);
    this.store.dispatch(LgaStoreActions.removeLga({ ids }));
  }
}
